module.exports = __webpack_public_path__ + "static/media/signage-indoor-img13.4d5ff382.jpg";